"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckpointState = void 0;
/** Possible Checkpoint states. */
var CheckpointState;
(function (CheckpointState) {
    /** Checkpoint generation completed successfully. */
    CheckpointState["Successful"] = "successful";
    /** Checkpoint generation is not yet complete, the background job is scheduled. */
    CheckpointState["Scheduled"] = "scheduled";
    /** Checkpoint generation failed. */
    CheckpointState["Failed"] = "failed";
    /** Checkpoint is not generated and the background job is not scheduled. */
    CheckpointState["NotGenerated"] = "notGenerated";
})(CheckpointState = exports.CheckpointState || (exports.CheckpointState = {}));
//# sourceMappingURL=CheckpointInterfaces.js.map